

























import {Component, Prop, Vue} from 'vue-property-decorator';
import AmetrasAdvancedFilterTemplate from '@/views/AmetrasAdvancedFilterTemplate.vue';
import AmetrasFormularWrapper from '@/views/AmetrasFormularWrapper.vue';
import Holidays, {HolidaysTypes} from 'date-holidays';
import {AMETRAS_HOLIDAY_UTILS_INST} from '@/services/holiday.service';

interface ExtendedHolidays {
  countryAndStateString: string;
  holidayCountry: HolidaysTypes.Country;
}

@Component({
  name: 'timeline-holiday-panel',
  components: {
    AmetrasFormularWrapper,
    AmetrasAdvancedFilterTemplate
  }
})
export default class TimelineHolidayPanelTemplate extends Vue {

  @Prop() value!: ExtendedHolidays;
  @Prop({
    type: Object as () => DisguiseDto.TimelineHolidayPanelContentDto,
    required: true
  }) panelContent!: DisguiseDto.TimelineHolidayPanelContentDto;

  holidayCountryAndState: ExtendedHolidays | null = null;
  holidayCountriesAndStates: ExtendedHolidays[] | null = null;

  created() {
    this.holidayCountriesAndStates = AMETRAS_HOLIDAY_UTILS_INST.getAllPossibleValues();
    // init current
    if (this.value) {
      this.holidayCountryAndState = this.value;
    } else {
      this.holidayCountryAndState = AMETRAS_HOLIDAY_UTILS_INST.getDefault();
    }
  }

  countryChanged(args: ExtendedHolidays) {
    this.holidayCountryAndState = args;
    let holidays: Holidays | null = null;
    const changes: DisguiseDto.HolidayDto = {};
    if (args !== null) {
      changes.country = args.holidayCountry.country;
      changes.state = args.holidayCountry.state;
      holidays = new Holidays(this.holidayCountryAndState.holidayCountry);
    }
    this.$emit('change', {
      holidays,
      selected: args
    });
  }

  captureEnterKey(event: Event) {
    const isAnySelectBoxOpened = document.querySelectorAll('.v-select--is-menu-active').length !== 0;
    if (isAnySelectBoxOpened) {
      event.stopPropagation();
    } else {
      event.stopImmediatePropagation();
    }
  }

}
